import { RootDispatch } from "redux/rootReducer";
import { load, loadSuccess, loadFail } from "./transactionsActions";
import * as request from "utility/request";
import { Portfolio } from "types/Transactions";

const apiUrl = process.env.REACT_APP_API_URL;

export const loadLogs = (
  reportControlId: string,
  startDate: string,
  endDate: string
) => {
  return async (dispatch: RootDispatch) => {
    dispatch(load());

    try {
      const res = await request.getResponseJson<Portfolio[]>(
        `${apiUrl}/api/transactions?reportControlId=${reportControlId}&startDate=${startDate}&endDate=${endDate}`
      );

      dispatch(loadSuccess(res));
    } catch (error) {
      return request.handleFetchError(dispatch, error, loadFail(error));
    }
  };
};
